import ContactEntity from '@/entities/api/users/contact'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ContactSlice {
	contacts: ContactEntity[]
	selectedContact: ContactEntity | null
}

const initialState: ContactSlice = {
	contacts: [],
	selectedContact: null,
}

const couponsSlice = createSlice({
	name: 'contacts',
	initialState,
	reducers: {
		selectContactFn: (state, action: PayloadAction<ContactEntity>) => {
			state.selectedContact = action.payload
		},
		setContactsFn: (state, action: PayloadAction<ContactEntity[]>) => {
			state.contacts = action.payload
		},
		addContactFn: (state, action: PayloadAction<ContactEntity>) => {
			state.contacts.push(action.payload)
		},
		updateContactFn: (state, action: PayloadAction<Partial<ContactEntity>>) => {
			const index = state.contacts.findIndex(
				(contact) => contact._id === action.payload._id
			)
			if (index !== -1) {
				state.contacts[index] = {
					...state.contacts[index],
					...action.payload,
				}
			}
		},
		updateSelectContactFn: (
			state,
			action: PayloadAction<Partial<ContactEntity>>
		) => {
			if (state.selectedContact) {
				state.selectedContact = {
					...state.selectedContact,
					...action.payload,
				}
			}
		},
		deleteContactFn: (state, action: PayloadAction<string>) => {
			state.contacts = state.contacts.filter(
				(contact) => contact._id !== action.payload
			)
		},
	},
})

export const {
	setContactsFn,
	selectContactFn,
	addContactFn,
	updateContactFn,
	updateSelectContactFn,
	deleteContactFn,
} = couponsSlice.actions

export default couponsSlice.reducer
